var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.724.053A.5.5 0 00.04.696L4.656 11.5.04 22.304a.5.5 0 00.684.643L22.617 11.95a.5.5 0 000-.902L.723.053zM20.291 11L1.497 1.56 5.53 11h14.76zM5.53 12l-4.034 9.44L20.29 12H5.53z",
    fill: "#525252"
  })));
}
SvgSendDisabled.displayName = 'SendDisabled';
export default SvgSendDisabled;